import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const getSolicitudesByIdEmision = async (idEmision) => {
  try {
    const serverResponse = await mainAxios.get(
      `/v1/solicitud/emision/${idEmision}`,
      getDefaultHeaders()
    );

    return serverResponse.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getReporteLogsAutorizacion = async (filters) => {
  try {
    const response = await mainAxios.get(
      "/v1/bradescard/reporte/autorizacion-folios",
      {
        params: {
          fechas: filters.fechas,
          limit: filters.limit ?? 10,
          page: filters.page ?? 0,
          order: filters.order ?? "desc",
        },
        paramsSerializer: (params) => {
          const searchParams = new URLSearchParams();
          for (const key in params) {
            if (Array.isArray(params[key])) {
              params[key].forEach((val) => searchParams.append(key, val));
            } else if (params[key] != null) {
              searchParams.append(key, params[key]);
            }
          }
          return searchParams.toString();
        },
        ...getDefaultHeaders(), 
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getReporteAutoriazionFoliosCSV = async (body) => {
  try {
    const response = await mainAxios.post(
      "/v1/bradescard/reporte/autorizacion-folios/file",
      body,
      getDefaultHeaders()
    );

    const blob = new Blob([response.data], {
      type: "application/csv;charset=utf-8;",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Reporte_Autorizacion_Folios.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error al descargar CSV:", error);
    throw error;
  }
};

export const getReporteRetenciones = async (body) => {
  try {
    const response = await mainAxios.post(
      "/v1/bradescard/reporte/retenciones",
      body,
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
}

export const getReporteRetencionesForDownload = async (body) => {
  try {
    const response = await mainAxios.post(
      "/v1/bradescard/reporte/retenciones/file",
      body,
      { ...getDefaultHeaders(), responseType: 'blob' }
    );
    return response;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
}